import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewManagerService } from '../../services/view-manager-service';

@Component({
  selector: 'app-footer',
  templateUrl: 'index-footer.component.html',
  styleUrls: ['./index-footer.component.css'],
  host: { '[attr.id]': '\'footer\'', '[attr.role]': '\'contentinfo\'' }
})
export class IndexFooterComponent implements OnInit {
  subscriptionPerStampa: Subscription;
  show: boolean = true;
  constructor(private viewManagerService: ViewManagerService) { }

  ngOnInit() {
    this.subscriptionPerStampa = this.viewManagerService.ctxHeader.subscribe(res => this.show = res);
  }

  ngOnDestroy() {
    this.subscriptionPerStampa.unsubscribe();
  }
}
